<template>
  <div style="height: calc(100% - 20px);padding-top: 16px">
    <div id="Manager" class="fullheight">
      <eco-table
        @load="loadData"
        :data="ruleConfigs"
        :pageResult="pageResult"
        :selectable="true"
        :selection="true"
        quick-search-props="F_form_name,F_form_key"
        :show-export="false"
        :show-custom-column="false"
        ref="ecoTable"
        hight="1000"
      >
        <template v-slot:toolbar>
          <el-button size="small" @click="showAddDialog()" type="primary">添加</el-button>
          <el-button size="small" @click="refresh()" style="margin-left: 16px">刷新</el-button>
          <fe-delete-button url="${business}/rule/bus_process_ctrl_rule/" style="margin-left: 16px" :htTable="$refs.ecoTable">删除</fe-delete-button>
        </template>
        <template>
          <eco-table-column type="index" width="50" align="center" label="序号" />
          <eco-table-column prop="F_form_name" label="表单名称" :sortable="true" :sort-by="'F_form_name'" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <el-link type="primary" :underline="false" @click="showModify(scope.row.id)"> {{ scope.row.form_name }}</el-link>
            </template>
          </eco-table-column>
          <eco-table-column prop="F_form_key" label="表单Key" :sortable="true" :sort-by="'F_form_key'" :show-overflow-tooltip="true"> </eco-table-column>
          <eco-table-column prop="detail_count" label="规则数" :sortable="false" :show-overflow-tooltip="true"> </eco-table-column>
        </template>
      </eco-table>

      <!--添加-->
      <rule-config-add :dialogVisible="addDialogVisible" @beforeClose="beforeAddClose"></rule-config-add>
      <!--编辑-->
      <rule-config-modify :dialogVisible="modifyDialogVisible" :selectModelId="selectModelId" @beforeClose="beforeModifyClose"></rule-config-modify>
    </div>
  </div>
</template>
<script>
import { Message } from 'element-ui'
import req from '@/request.js'
const ruleConfigAdd = () => import('@/components/tenant/rule/RuleConfigAdd.vue')
const ruleConfigModify = () => import('@/components/tenant/rule/RuleConfigModify.vue')

export default {
  components: {
    ruleConfigAdd,
    ruleConfigModify
  },
  props: {},
  data() {
    return {
      addDialogVisible: false,
      modifyDialogVisible: false,
      ruleConfigs: [],
      pageResult: {
        page: 1,
        pageSize: 20,
        total: 0
      },
      tenantId: '-1',
      model: {},
      selectModelId: '',
      isView: true,
      isEdit: false,
      saveMethod: 'POST',
      formConfig: {},
      formList: []
    }
  },
  mounted() {},
  methods: {
    showAddDialog() {
      this.addDialogVisible = true
    },
    showModify(id) {
      this.selectModelId = id
      this.modifyDialogVisible = true
    },
    // 关闭添加
    beforeAddClose() {
      this.model = null
      this.addDialogVisible = false
      this.loadData()
    },
    // 关闭
    beforeModifyClose() {
      this.selectModelId = null
      this.modifyDialogVisible = false
      this.loadData()
    },
    loadData(param, cb) {
      const tenantId = typeof sessionStorage.getItem('tenantId') == 'undefined' ? sessionStorage.getItem('tenantId') : sessionStorage.getItem('currentTenantId')
      if (tenantId) {
        this.tenantId = tenantId
      } else {
        this.tenantId = '-1'
      }
      if (param && cb) {
        const obj = {
          param: param,
          cb: cb
        }
        sessionStorage.setItem('ruleConfigLoadJSON', JSON.stringify(obj))
      }
      if (!param) {
        const session = JSON.parse(sessionStorage.getItem('ruleConfigLoadJSON'))
        param = session.param
        cb = session.cb
      }
      if (this.tenantId) {
        req
          .post('${business}/rule/bus_process_ctrl_rule/query?tenantId=' + this.tenantId, param)
          .then(
            (resp) => {
              let response = resp.data
              this.ruleConfigs = response.rows
              this.ruleConfigs.forEach((rule) => {
                rule.F_form_key = rule.form_key
                rule.F_form_name = rule.form_name
              })
              this.pageResult = {
                page: response.page,
                pageSize: response.pageSize,
                total: response.total
              }
            },
            (error) => {
              reject(error)
            }
          )
          .finally(() => cb())
      } else {
        this.ruleConfigs = []
        this.pageResult = {
          page: 1,
          pageSize: 50,
          total: 0
        }
      }
    },
    afterSaveData() {
      setTimeout(() => {
        this.beforeCloseDialog()
        this.$refs.ecoTable.load()
      }, 500)
    },
    async refresh() {
      this.$confirm('不选择刷新所有规则，确定要刷新吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          let ids = []
          for (let item of this.$refs.ecoTable.selection) {
            ids.push(item['id'])
          }
          this.fullscreenLoading = true
          let response = await req
            .request({
              url: '${business}/rule/bus_process_ctrl_rule/sync?ids=' + ids.join(','),
              method: 'GET'
            })
            .finally(() => {
              this.fullscreenLoading = false
            })

          if (response.data && response.data.state) {
            this.$message({
              message: response.data.message || '操作成功',
              showClose: true,
              type: 'success'
            })
          }
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped></style>
